import { useBreakpoint } from '@ocean/hooks'
import { layouts } from '@ocean/ui'
import { LayoutProps, PageHeaderLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import { Root, TopSegment, Title, Content } from './PageHeaderLayout.styled'

const { SectionLayout } = layouts

export type PageHeaderLayoutSegments = 'top' | 'title' | 'content'
type InternalLayoutProps = LayoutProps<PageHeaderLayoutSegments>

export const PageHeaderSegment: React.FC<PageHeaderLayoutSegmentProps> = ({ children }) => (
  <>{children}</>
)

const PageHeaderLayout = ({ segments, mode }: InternalLayoutProps) => {
  const isDesktop = useBreakpoint('sm')

  function renderTopSegment() {
    if (!isDesktop && !segments?.top) return null
    return <TopSegment>{segments?.top && segments.top}</TopSegment>
  }

  return (
    <Root mode={mode}>
      <SectionLayout>
        {renderTopSegment()}
        <Title>{segments?.title}</Title>
        {segments?.content && <Content>{segments.content}</Content>}
      </SectionLayout>
    </Root>
  )
}

export default withLayout(PageHeaderLayout)
